import styled from 'styled-components';

export default styled.div`
	gap: var(--spacing-x-large);
	display: flex;
	flex-direction: column;
	min-height: 0;
	height: -webkit-fill-available;
	scrollbar-gutter: stable;
	.motif-progress-loader-container {
		z-index: 2;
	}
	.instruction-text {
		display: flex;
		flex-direction: column;
	}
`;
